export function checkIfUser(userAgent: string): boolean {
  const isBot = /bot|googlebot|crawler|spider|robot|crawling|zgrab|BW\/1.1|AppEngine-Google|facebookexternalhit/i.test(userAgent);
  const isHostTracker = /HostTracker/i.test(userAgent);

  return !isBot && !isHostTracker;
}
